import styled from 'styled-components';

const TableWrapper = styled.div`
    width: 100%;
    height: 95%;
    padding-top: 9px;
`;

export default TableWrapper;
